<template>
	<v-overlay :model-value="overlay" class="align-center justify-center">
    <v-progress-circular
      style="color: rgba(21, 102, 124, 0.9)"
      indeterminate
      size="64"
    ></v-progress-circular>
  </v-overlay>
  <v-layout>
    <Header v-on:studyChange="selectStudy"></Header>
    <v-main>
      <v-dialog v-model="dialogMain" width="1200">
        <v-card style="text-align: left; background: rgb(240, 240, 240);" min-height="420">
          <v-row class="emailRow">
            <v-col cols="12" md="3" class="text-left">
              <v-dialog v-model="dialogUpdate" width="500">
                <template v-slot:activator="{ props }">
                  <v-btn
                    dark
                    style="
                      float: left;
                      background: rgba(21, 102, 124, 0.2);
                      border: 2px solid #297286;
                    "
                    variant="outlined"
                    v-bind="props"
                    :disabled="isDisable"
                    v-if="otherButtonsVisible"
                    >Update</v-btn
                  >
                </template>
                <v-card>
                  <v-card-title class="text-h5 grey lighten-2">
                    Are you sure you want to update?
                  </v-card-title>
                  <v-row style="text-align: start">
                    <v-col cols="3">
                      <span class="clarificationText"> First Name:</span>
                    </v-col>
                    <v-col cols="9">
                      {{ firstName || "No First Name" }}
                    </v-col>
                  </v-row>
                  <v-row style="text-align: start">
                    <v-col cols="3">
                      <span class="clarificationText">Last Name:</span>
                    </v-col>
                    <v-col cols="9">
                      {{ lastName || "No LastName" }}
                    </v-col>
                  </v-row>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      dark
                      style="
                        float: left;
                        background: rgba(21, 102, 124, 0.2);
                        border: 2px solid #297286;
                      "
                      variant="outlined"
                      @click="runUpdate"
                    >
                      Update
                    </v-btn>
                    <v-btn
                      dark
                      style="
                        float: left;
                        background: rgba(128, 128, 128, 0.2);
                        border: 2px solid #297286;
                      "
                      variant="outlined"
                      @click="dialogUpdate = false"
                    >
                      Cancel
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="dialogDelete" width="500">
                <template v-slot:activator="{ props }">
                  <v-btn
                    dark
                    style="
                      float: left;
                      background-color: rgb(122, 0, 0, 0.2);
                      border: 2px solid #297286;
                    "
                    variant="outlined"
                    v-bind="props"
                    :disabled="!firstName"
                    v-if="otherButtonsVisible"
                    >Delete</v-btn
                  >
                </template>
                <v-card>
                  <v-card-title class="text-h5 grey lighten-2">
                    Are you sure you want to delete?
                  </v-card-title>
                  <v-row style="text-align: start">
                    <v-col cols="3">
                      <span class="clarificationText"> First Name:</span>
                    </v-col>
                    <v-col cols="9">
                      {{ firstName || "No First Name" }}
                    </v-col>
                  </v-row>
                  <v-row style="text-align: start">
                    <v-col cols="3">
                      <span class="clarificationText">Last Name:</span>
                    </v-col>
                    <v-col cols="9">
                      {{ lastName || "No LastName" }}
                    </v-col>
                  </v-row>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      dark
                      style="
                        float: left;
                        background-color: rgb(122, 0, 0, 0.2);
                        border: 2px solid #297286;
                      "
                      variant="outlined"
                      @click="runDelete"
                    >
                      Delete
                    </v-btn>
                    <v-btn
                      dark
                      style="
                        float: left;
                        background: rgba(128, 128, 128, 0.2);
                        border: 2px solid #297286;
                      "
                      variant="outlined"
                      @click="dialogDelete = false"
                    >
                      Cancel
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="dialogAdd" width="500">
                <template v-slot:activator="{ props }">
                  <v-btn
                    dark
                    style="
                      float: left;
                      background: white;
                      border: 2px solid #297286;
                    "
                    variant="outlined"
                    v-bind="props"
                    :disabled="isDisableToAdd"
                    v-if="addButtonVisible"
                    >Add</v-btn
                  >
                </template>
                <v-card>
                  <v-card-title class="text-h5 grey lighten-2">
                    Are you sure you want to add?
                  </v-card-title>
                  <v-row style="text-align: start">
                    <v-col cols="3">
                      <span class="clarificationText"> First Name:</span>
                    </v-col>
                    <v-col cols="9">
                      {{ firstName || "No First Name" }}
                    </v-col>
                  </v-row>
                  <v-row style="text-align: start">
                    <v-col cols="3">
                      <span class="clarificationText">Last Name:</span>
                    </v-col>
                    <v-col cols="9">
                      {{ lastName || "No LastName" }}
                    </v-col>
                  </v-row>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      dark
                      style="
                        float: left;
                        background: white;
                        border: 2px solid #297286;
                      "
                      variant="outlined"
                      @click="runUpdate"
                    >
                      Add
                    </v-btn>
                    <v-btn
                      dark
                      style="
                        float: right;
                        background: rgba(128, 128, 128, 0.2);
                        border: 2px solid #297286;
                      "
                      variant="outlined"
                      @click="dialogAdd = false"
                    >
                      Cancel
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-col>
            <v-col cols="12" md="5" class="ma-0 text-right">
            <strong
              ><span style="color: rgba(21, 102, 124, 0.9)">
                First Name and Last Name cannot be changed.
              </span></strong
            ></v-col>
            <v-col cols="12" md="4" class="ma-0 text-right">
              <v-btn
                dark
                style="
                  float: right;
                  background: rgba(128, 128, 128, 0.2);
                  border: 2px solid #297286;
                "
                variant="outlined"
                @click="clearForm"
                >Cancel</v-btn
              >
            </v-col>
          </v-row>
          <v-card-text style="font-size: 16px; color: black">
            <v-row style="margin-top: 15px;">
              <v-col cols="12" md="2" class="ma-0">First Name </v-col>
              <v-col cols="12" md="3">
                <v-text-field
								class="managementFormFields"
                  variant="outlined"
                  dense
                  hide-details
                  v-model="firstName"
                  disabled
									density="compact"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="1">Area </v-col>
              <v-col cols="12" md="3">
                <v-text-field
								class="managementFormFields"
                  variant="outlined"
                  dense
                  hide-details
                  v-model="area"
                  required
									density="compact"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="1"><div>Spanish</div></v-col>
              <v-col cols="12" md="1" class="checkboxField">
                <v-checkbox v-model="spanish" hide-details></v-checkbox>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="2">Last Name </v-col>
              <v-col cols="12" md="3">
                <v-text-field
								class="managementFormFields"
                  variant="outlined"
                  dense
                  hide-details
                  v-model="lastName"
                  disabled
									density="compact"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="1">Region </v-col>
              <v-col cols="12" md="3">
                <v-text-field
								class="managementFormFields"
                  variant="outlined"
                  dense
                  hide-details
                  v-model="region"
                  required
									density="compact"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="1">Travel </v-col>
              <v-col cols="12" md="1" class="checkboxField">
                <v-checkbox v-model="travel" hide-details=""></v-checkbox>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="2">Status </v-col>
              <v-col cols="12" md="3">
                <v-select
								class="managementFormFields"
                  :items="statusItems"
                  :item-title="title"
                  :item-value="value"
                  variant="outlined"
                  dense
                  hide-details
                  v-model="status"
                  required
									density="compact"
                ></v-select>
              </v-col>

              <v-col cols="12" md="1">PSU </v-col>
              <v-col cols="12" md="3">
                <v-text-field
								class="managementFormFields"
                  variant="outlined"
                  dense
                  hide-details
                  v-model="psu"
                  required
									density="compact"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="2">Roles</v-col>
              <v-col cols="12" md="3" style="margin-top: -15px">
              </v-col>
              <v-col cols="12" md="1">Segment </v-col>
              <v-col cols="12" md="3">
                <v-text-field
								class="managementFormFields"
                  variant="outlined"
                  dense
                  hide-details
                  v-model="segment"
                  required
									density="compact"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row style="height: 50px;">
              <v-col cols="12" md="2"><div>Task Validation</div></v-col>
              <v-col cols="12" md="3" class="checkboxField">
                <v-checkbox v-model="taskValidationAccess" hide-details></v-checkbox>
              </v-col>
              <v-col cols="12" md="1">Email <v-switch v-model="emailEditable" hint="Careful changing email"></v-switch></v-col>
              <v-col cols="12" md="3">
                <v-text-field
								  class="managementFormFields"
                  variant="outlined"
                  dense
                  hide-details
                  v-model="email"
									density="compact"
                  :disabled=emailEditable
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="2"><div>Case Assignment</div></v-col>
              <v-col cols="12" md="1" class="checkboxField">
                <v-checkbox v-model="caseAssignmentAccess" hide-details></v-checkbox>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="2"><div>Operations</div></v-col>
              <v-col cols="12" md="1" class="checkboxField">
                <v-checkbox v-model="operationsAccess" hide-details></v-checkbox>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <div id="managementFilterForm">
        <v-row no-gutters>
          <v-col class="pe-2">
            <div class="searchTitle">LAST NAME</div>
            <v-row>
              <v-col>
                <v-text-field
									class="managementFormFields"
                  hide-details
                  v-model="searchLastName"
                  variant="outlined"
									density="compact"
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="pe-2">
            <div class="searchTitle">FIRST NAME</div>
            <v-row>
              <v-col>
                <v-text-field
									class="managementFormFields"
                  hide-details
                  v-model="searchFirstName"
                  variant="outlined"
									density="compact"
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="pe-2">
            <div class="searchTitle">STAFF ID</div>
            <v-row>
              <v-col>
                <v-text-field
									class="managementFormFields"
                  hide-details
                  v-model="searchStaffId"
                  variant="outlined"
									density="compact"
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="pe-2">
            <div class="searchTitle">ROLE</div>
            <v-row>
              <v-col>
                <v-select
									class="managementFormFields"
                  hide-details
                  :items="primaryRolesList"
                  v-model="searchRole"
                  item-title="title"
                  item-value="value"
                  variant="outlined"
									density="compact"
                >
                </v-select>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="pe-2">
            <div class="searchTitle">STATUS</div>
            <v-row>
              <v-col>
                <v-select
									class="managementFormFields"
                  hide-details
                  :items="statusItems"
                  item-title="title"
                  item-value="value"
                  v-model="searchStatus"
                  variant="outlined"
									density="compact"
                >
                </v-select>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="pe-2">
            <div class="searchTitle">EMAIL</div>
            <v-row>
              <v-col>
                <v-text-field
									class="managementFormFields"
                  hide-details
                  variant="outlined"
                  v-model="searchEmail"
									density="compact"
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="2">
            <div class="searchTitle">&nbsp</div>
            <v-row>
              <v-col cols="12">
                <v-btn
                  small
                  dark
                  style="
                    float: right;
                    background: rgb(128, 128, 128, 0.2);
                    border: 2px solid #297286;
                  "
                  @click="clearSearchBar"
                  variant="outlined"
                  >Clear</v-btn
                >
                <v-btn
                  small
                  dark
                  style="
                    float: right;
                    background: rgb(0, 0, 122, 0.2);
                    border: 2px solid #297286;
                  "
                  variant="outlined"
                  @click="runSearch"
                  >Search</v-btn
                >
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
      <v-row no-gutters class="managementTableInfo">
        <v-spacer></v-spacer>
        <strong>Click on row to edit</strong>
        <v-spacer></v-spacer>
      </v-row>
      <row no-gutters>
        <ag-grid-vue
          style="width: 100%; height: 1000px !important;"
          class="ag-theme-balham elevation-2 managementGrid"
          :columnDefs="this.columnDefs"
          :rowData="rowData"
          :gridOptions="gridOptions"
          :rowSelection="rowSelection"
          @selection-changed="onSelectionChanged"
          pagination="true"
          :overlayNoRowsTemplate="overlayNoRowsTemplate"
          @grid-ready="onGridReady"
        >
        </ag-grid-vue>
      </row>
    </v-main>
  </v-layout>
</template>

<script>
import { AgGridVue } from "ag-grid-vue3";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { authTokenService } from "@/services/authTokenService.js";
import { authService } from "@/services/authService.js";
import { commonService } from "@/services/common.service.js";
import { managementService } from "@/services/management.service.js";
// import { runInThisContext } from "vm";
import { STORE_CONSTANTS } from "@/common/store.constants";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "management",
  components: {
    AgGridVue,
    Header,
    Footer,
  },
  data: () => ({
    STORE_CONSTANTS,
    columnDefs: [
      {
        headerName: "Last Name",
        field: "nameLast",
        resizable: true,
        sortable: true,
        filter: true,
        width: 140,
				cellStyle: { textAlign: 'left' },
      },
      {
        headerName: "First Name",
        field: "nameFirst",
        resizable: true,
        sortable: true,
        filter: true,
        width: 140,
				cellStyle: { textAlign: 'left' },
      },
      {
        headerName: "Email",
        field: "email",
        resizable: true,
        sortable: true,
        filter: true,
        width: 170,
				cellStyle: { textAlign: 'left' },
      },
      {
        headerName: "Staff Id",
        field: "staffId",
        resizable: true,
        sortable: true,
        filter: true,
        width: 100,
				cellStyle: { textAlign: 'left' },
      },
      {
        headerName: "AD Id",
        field: "wesnetId",
        resizable: true,
        sortable: true,
        filter: true,
        width: 100,
				cellStyle: { textAlign: 'left' },
      },
      {
        headerName: "WINS",
        field: "westatId",
        resizable: true,
        sortable: true,
        filter: true,
        width: 80,
				cellStyle: { textAlign: 'left' },
      },
      {
        headerName: "Role",
        field: "role",
        resizable: true,
        sortable: true,
        filter: true,
        width: 120,
        cellStyle: (params) => {
          if (params.value === "ROLE_OPERATIONS") {
            return { backgroundColor: "rgb(0,128,0,0.2)" };
          }
          if (params.value === "ROLE_USER") {
            return { backgroundColor: "rgb(0,0,255,0.2)" };
          }
          if (params.value === "FIELD_INTERVIEWER") {
            return { backgroundColor: "rgb(0,128,128,0.2)" };
          }
          if (params.value === "FIELD_SUPERVISOR") {
            return { backgroundColor: "rgb(128,0,128,0.2)" };
          }
          if (params.value === "FIELD_OPERATIONS") {
            return { backgroundColor: "rgb(128,128,128,0.2)" };
          }
          if (params.value === "ROLE_SPECIALIST") {
            return { backgroundColor: "rgb(255,255,0,0.2)" };
          }
          return null;
        },
      },
      {
        headerName: "Area",
        field: "area",
        resizable: true,
        sortable: true,
        filter: true,
        width: 100,
				cellStyle: { textAlign: 'left' }
      },
      {
        headerName: "Region",
        field: "region",
        resizable: true,
        sortable: true,
        filter: true,
        width: 100,
				cellStyle: { textAlign: 'left' }
      },
      {
        headerName: "PSU",
        field: "psu",
        resizable: true,
        sortable: true,
        filter: true,
        width: 100,
				cellStyle: { textAlign: 'left' }
      },
      {
        headerName: "Spanish",
        field: "spanish",
        resizable: true,
        sortable: true,
        filter: true,
        width: 120,
				cellStyle: { textAlign: 'left' }
      },
      {
        headerName: "Travel",
        field: "travel",
        resizable: true,
        sortable: true,
        filter: true,
        width: 100,
				cellStyle: { textAlign: 'left' }
      },
    ],
    rowData: [],
    selectedRowData: null,
    loading: false,
    rowSelection: "single",
    gridApi: null,
    results: null,
    totalItems: null,
    overlayNoRowsTemplate: null,
    drawer2: false,
    study: null,
    claims: null,
    APIVersion: null,
    email: null,
    emailEditable: true,
    firstName: null,
    area: null,
    spanish: null,
    lastName: null,
    region: null,
    travel: null,
    domain: null,
    psu: null,
    primaryRole: null,
    segment: null,
    emial: null,
    status: null,
    closeOnContentClick: true,
    tempUserInfo: null,
    primaryRolesList: [
      {
        title: "Operations",
        value: "ROLE_OPERATIONS",
      },
      {
        title: "Task Validation",
        value: "ROLE_SPECIALIST",
      },
      {
        title: "Case Assigment",
        value: "ROLE_SUPERVISOR",
      },
    ],
    extraRoleItems: [
      {
        title: "Task Validation",
        value: "ROLE_SPECIALIST",
      },
      {
        title: "Case Assigment",
        value: "ROLE_SUPERVISOR",
      },
      {
        title: "Operations",
        value: "ROLE_OPERATIONS",
      },
    ],
    extraRoles: [],
    statusItems: [
      { title: "Active", value: true },
      { title: "Inactive", value: false },
    ],
    searchLastName: null,
    searchFirstName: null,
    searchStaffId: null,
    searchRole: null,
    searchStatus: null,
    searchEmail: null,
    dialogDelete: false,
    dialogUpdate: false,
    dialogAdd: false,
    dialogMain: false,
    dialogForAdding: false,
    rulesGeneral: [(v) => v !== null || "Required"],
    addButtonVisible: false,
    otherButtonsVisible: false,
		overlay: false,
    taskValidationAccess: false,
    caseAssignmentAccess: false,
    operationsAccess: false
  }),
  beforeMount() {
    this.gridOptions = {};

  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
    window.addEventListener("resize", this.onResize);
  },
  created() {
    var token = this.$route.query.token;
    if (token != null) {
      authTokenService.saveToken(token);
    }
    this.claims = authTokenService.getClaims();
    this.study = this.$store.getters["study/getSelectedStudyId"] || authTokenService.getSelectedStudy();
    const me = this;
    commonService
      .getUIAndApiVersion()
      .then(function (response) {
        if (response && response.data) {
          me.APIVersion = response.data.version;
        }
      })
      .catch(function (e) {
        console.log(e);
      });
    this.email = this.claims.username;
    this.overlayNoRowsTemplate =
      '<span style="padding: 10px; border: 2px solid #117975; background: #e0e0e0; font-size: 14px">There is no data for this query.</span>';
  },
  updated() {
    this.onResize();
  },
  beforeUnmount() {
    this.gridApi.destroy();

    window.removeEventListener("resize", this.onResize);
  },
  watch: {
    primaryRole(newValue, oldValue) {
      if (
        newValue === "ROLE_SPECIALIST" &&
        !this.extraRoles.includes("ROLE_SPECIALIST")
      ) {
        this.extraRoles.push("ROLE_SPECIALIST");
      }
      if (
        newValue === "ROLE_SUPERVISOR" &&
        !this.extraRoles.includes("ROLE_SUPERVISOR")
      ) {
        this.extraRoles.push("ROLE_SUPERVISOR");
      }
      if (
        newValue === "ROLE_OPERATIONS" &&
        !this.extraRoles.includes("ROLE_OPERATIONS")
      ) {
        this.extraRoles.push("ROLE_OPERATIONS");
      }
    },
		dialogMain (newValue, oldValue){
			if (oldValue == true && newValue == false){
				// this.gridApi.deselectAll() // causing error, but why
				// this.gridApi.selectAll() // works
			}
		}
  },
  computed: {
    isDisable() {
      return this.status === null;
    },
    isDisableToAdd() {
      return (
        this.extraRoles.length === 0 ||
        this.status === null ||
        this.firstName === null ||
        this.lastName === null
      );
    },
  },
  methods: {
    getMainRole() {
      const me = this;
      var role;
      if (me.operationsAccess) {
        role = "ROLE_OPERATIONS";
      } else if (me.taskValidationAccess){
        role = "ROLE_SPECIALIST";
      } else if (me.caseAssignmentAccess){
        role = "ROLE_SUPERVISOR";
      }
      return role;
    },
    getArrayOfNewRolesToAdd() {
      const me = this;
      var extraRolesArray = []
      if (me.taskValidationAccess){
        extraRolesArray.push('ROLE_SPECIALIST')
      }
      if (me.caseAssignmentAccess){
        extraRolesArray.push('ROLE_SUPERVISOR')
      }
      if (me.operationsAccess){
        extraRolesArray.push('ROLE_OPERATIONS')
      }
      var arrayOfRolesObjectsToPush = [];
      for (const eR of extraRolesArray) {
        var newRoleObject = {
          author: this.claims.username,
          authority: "EAGLE",
          dateUpdate: Date.now(),
          role: eR,
          source: "EAGLE",
        };
        arrayOfRolesObjectsToPush.push(newRoleObject);
      }
      var finalArrayOfObjects = arrayOfRolesObjectsToPush;
      return finalArrayOfObjects;
    },
    goToAssignment() {
      this.$router.push("/assignment");
    },
    goToValidation() {
      this.$router.push("/validation");
    },
    logout() {
      authService.logout(false);
    },
    selectStudy(study) {
      this.study = study;
      this.$store.commit(
        this.STORE_CONSTANTS.STUDY.MUTATIONS.WITH_NAMESPACE
          .SET_SELECTED_STUDY_ID,
        study
      );
    },
    runSelectedStaff(selectedStaff) {
      const me = this;
      me.email = selectedStaff.email;
      me.firstName = selectedStaff.nameFirst;
      me.lastName = selectedStaff.nameLast;
      me.status = selectedStaff.active;
      var filteredRolesAry = [];
      console.log('selectedStaff.roles: ', selectedStaff.roles)
      if (selectedStaff.roles) {
        var roleObjs = selectedStaff.roles;
        for (let piece of roleObjs) { 
            filteredRolesAry.push(piece.role);
        }
      }
      me.taskValidationAccess = filteredRolesAry.includes('ROLE_SPECIALIST')
      me.caseAssignmentAccess = filteredRolesAry.includes('ROLE_SUPERVISOR')
      me.operationsAccess = filteredRolesAry.includes('ROLE_OPERATIONS')
      me.extraRoles = filteredRolesAry;
      me.area = selectedStaff.area;
      me.region = selectedStaff.region;
      me.psu = selectedStaff.psu;
      me.segment = selectedStaff.segment;
      me.email = selectedStaff.email;
      me.spanish = selectedStaff.spanish;
      me.travel = selectedStaff.travel;
      me.domain = selectedStaff.organisation;
    },
    runUpdate() {
      const me = this;
      me.dialogUpdate = false;
      me.dialogMain = false;
      me.tempUserInfo.active = me.status;
      me.tempUserInfo.area = me.area;
      me.tempUserInfo.psu = me.psu;
      me.tempUserInfo.region = me.region;
      me.tempUserInfo.role = me.getMainRole();
      me.tempUserInfo.roles = me.getArrayOfNewRolesToAdd();
      me.tempUserInfo.segment = me.segment;
      me.tempUserInfo.email = me.email;
      me.tempUserInfo.spanish = me.spanish;
      me.tempUserInfo.travel = me.travel;
      me.tempUserInfo.dateUpdate = Date.now();
      console.log("me.tempUserInfo", me.tempUserInfo);
      var criteria = {
        study: me.study,
        staffUUID: me.tempUserInfo.staffUUID,
      };
      managementService
        .updateUser(criteria, me.tempUserInfo)
        .then(function () {
          window.setTimeout(() => me.runSearch(), 1000);
        })
        .catch(function (e) {
          console.log(e);
          this.clearForm();
        });
    },
    runDelete() {
      const me = this;
      me.dialogDelete = false;
      me.dialogMain = false;
      var criteria = {
        study: this.study,
        staffUUID: this.tempUserInfo.staffUUID,
      };
      managementService
        .deleteUser(criteria)
        .then(function () {
          window.setTimeout(() => me.runSearch(), 1000);
        })
        .catch(function (e) {
          console.log(e);
          this.clearForm();
        });
    },
    runSearch() {
      const me = this;
			me.overlay = true;
      var criteria = {
        study: me.study,
        lastName: me.searchLastName,
        firstName: me.searchFirstName,
        staffId: me.searchStaffId,
        role: me.searchRole,
        status: me.searchStatus,
        email: me.searchEmail,
      };
      managementService
        .findUser(criteria)
        .then(function (response) {
          if (response && response.data) {
            me.rowData = response.data;
          } else {
            me.rowData = [];
          }
					me.overlay = false;
        })
        .catch(function (e) {
          console.log(e);
          me.clearForm();
					me.overlay = false;
        });
    },
    clearForm() {
      const me = this;
      me.email = null;
      me.firstName = null;
      me.area = null;
      me.spanish = null;
      me.lastName = null;
      me.region = null;
      me.travel = null;
      me.domain = null;
      me.psu = null;
      me.primaryRole = null;
      me.segment = null;
      me.email = null;
      me.userManagement = null;
      me.status = null;
      me.dialogMain = false;
      me.dialogForAdding = false;
    },
    clearSearchBar() {
      let me = this;
      me.searchLastName = null;
      me.searchFirstName = null;
      me.searchStaffId = null;
      me.searchRole = null;
      me.searchStatus = null;
      me.searchEmail = null;
      me.rowData = null;
    },
    onResize(event) {
      this.gridApi.sizeColumnsToFit();
    },
    onGridReady(params) {
      // this.gridApi = params.api;
      // this.gridColumnApi = params.columnApi;
      params.api.sizeColumnsToFit();
    },
    onSelectionChanged() {
      this.selectedRowData = this.gridApi.getSelectedRows();
      console.log("this.selectedRowData", this.selectedRowData);
      this.tempUserInfo = null;
      this.tempUserInfo = this.selectedRowData[0];
      this.runSelectedStaff(this.selectedRowData[0]);
      this.dialogMain = true;
      if (
        this.tempUserInfo.role === null &&
        this.tempUserInfo.active === null
      ) {
        this.addButtonVisible = true;
        this.otherButtonsVisible = false;
      } else {
        this.addButtonVisible = false;
        this.otherButtonsVisible = true;
      }
    },
  },
};
</script>

<style scoped>
#managementContainer {
  text-align: left !important;
  /* margin-top: 20px; */
}
.v-text-field__details {
  display: none;
}
.checkboxField {
  display: flex;
  justify-content: flex-end !important;
  margin-top: -17px;
}
#managementFilterForm {
  padding: 4px 15px 7px 15px;
  background: rgb(240, 240, 240);
}
.row + .row {
  margin-top: 0px;
}
.emailRow {
  padding: 10px 10px;
  max-height: 70px;
  background: rgb(224, 224, 224);
}
.managementTableInfo {
	color: rgba(21, 102, 124, 0.9);
  background: rgb(224, 224, 224);
}
.formInfo {
  margin: 0px 10px;
  max-height: 25px;
}
.v-btn {
  margin: 0px 2px;
}
.theme--dark.v-btn.v-btn--disabled.v-btn--has-bg {
  background-color: grey !important;
}
.clarificationText {
  margin-left: 20px;
}

.managementFormFields {
	background: white;
}
</style>
